import { render, staticRenderFns } from "./amountEnterprise.vue?vue&type=template&id=2b9812d8&scoped=true&"
import script from "./amountEnterprise.vue?vue&type=script&lang=js&"
export * from "./amountEnterprise.vue?vue&type=script&lang=js&"
import style0 from "./amountEnterprise.vue?vue&type=style&index=0&id=2b9812d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9812d8",
  null
  
)

export default component.exports